import { FC, useState } from 'react';
import styled from 'styled-components';

import { useNotices } from '@/features/notices/useNotices';
import { useDocuments } from '@/features/vfo/hooks/useDocuments';
import { breakpoints, media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { DeleteDocumentModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../../interwill/containers/ModalContainerV2';

export const DeleteDocumentModal: FC<DeleteDocumentModalProps> = ({ fileId }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'deleteDocument' });

  const [loading, setLoading] = useState(false);
  const notices = useNotices();
  const { deleteDocument } = useDocuments();
  const { closeModal } = useModalsStore();

  const handleDelete = async () => {
    setLoading(true);
    const ok = await deleteDocument(fileId);
    setLoading(false);
    if (!ok) return;
    notices.success(t('successNotice'));
    closeModal();
  };

  return (
    <ModalContainerV2 pinBottom title={t('title')}>
      <TextContainer>
        <span>{t('text1')}</span>
        <span>{t('text2')}</span>
      </TextContainer>
      <Buttons>
        <Button type="default" size="middle" onClick={closeModal}>
          {t('cancel')}
        </Button>
        <ButtonDestructive
          disabled={loading}
          loading={loading}
          size="middle"
          onClick={handleDelete}
        >
          {t('delete')}
        </ButtonDestructive>
      </Buttons>
    </ModalContainerV2>
  );
};

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 24px 0;
  font-size: 14px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  gap: 16px;

  ${media.md}, ${breakpoints.sm} {
    flex-direction: column-reverse;
  }
`;

const ButtonDestructive = styled(Button)`
  &&& {
    background-color: ${COLORS.systemFlame200};
    color: ${COLORS.white};
  }
`;
